<template>
  <el-dialog
    title="数据绑定方式选择"
    v-dialogDrag
    :visible.sync="dialogVisible"
    append-to-body
    :close-on-click-modal="false"
    class="mini-dialog"
  >
    <el-row>
      <el-col :span="24" class="mt-20px flex items-center justify-center">
        <el-radio v-model="mode" :label="1" size="small">表绑定</el-radio>
        <el-radio v-model="mode" :label="2" size="small">字段绑定</el-radio>
      </el-col>
      <el-col :span="24" class="mt-20px">
        <p class="text-[#f56c6c] text-18px">说明：</p>
        <p class="text-[#f56c6c] mt-10px">1.表绑定模式：字段列表拖拽到模板后，和数据表进行绑定</p>
        <p class="text-[#f56c6c] mt-10px">
          2.单元格绑定模式：适用于单值采集，字段列表拖拽到模板后，和单元格进行绑定（只采集单元格的数据）
        </p>
      </el-col>
    </el-row>
    <template #footer>
      <div class="flex justify-center">
        <el-button type="primary" size="small" @click="modeChange">确认</el-button>
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'modeChange',
  props: {
    visible: {
      type: Boolean,
      default: false,
    }, // 弹窗显隐
    modeType: {
      type: Number,
      default: 1,
    }, // 绑定模式
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  created() {
    this.mode = this.modeType
  },
  data() {
    return {
      mode: '', // 模式
    }
  },
  methods: {
    /**
     * @description 确认切换模式
     */
    modeChange() {
      this.$emit('modeChange', this.mode)
      this.dialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>

::v-deep .el-form-item__label {
  text-align: right;
}
::v-deep .el-card__body {
  height: 100%;
}

</style>
